import React, { useState } from 'react';

import MobileDrawer from '@/components/common/mobileDrawer';
import * as Styles from './styles';

interface BMVModalProps {
    items: { id: number | string; name?: string }[];
    isMobile: boolean;
    heading: string;
    showModal: boolean;
    placeholder: string;
    itemsStatus: boolean | undefined;
    values?: { id: number | string; name?: string };
    closeModal: () => void;
    getSelectedItem: any;
}

export default function BMVModal(props: BMVModalProps) {
    const {
        isMobile,
        items,
        heading,
        showModal,
        itemsStatus,
        closeModal,
        getSelectedItem,
        values,
        placeholder,
    } = props;
    const [searchStr, setSearchStr] = useState('');

    const content = () => (
        <>
            <Styles.CustomInputWrapper>
                {/* <Styles.SearchIcon src={Search} /> */}
                <Styles.CustomInput
                    placeholder={placeholder}
                    value={searchStr}
                    handleInputs={(e: any) => setSearchStr(e.target.value)}
                    margin="0"
                    iconType="search"
                    width={'100%'}
                    mWidth={'100%'}
                    name=""
                    label=""
                />
            </Styles.CustomInputWrapper>
            {typeof itemsStatus !== 'undefined' ? (
                <div>Loader</div>
            ) : itemsStatus === false ||
              (Array.isArray(items) && items?.length === 0) ? (
                <>
                    <div>No results found</div>
                </>
            ) : (
                <Styles.ItemsWrapper>
                    {Array.isArray(items) &&
                        items
                            ?.filter((s) =>
                                searchStr
                                    ? s?.name
                                          ?.toString()
                                          ?.toLocaleLowerCase()
                                          .includes(
                                              searchStr
                                                  ?.toString()
                                                  ?.toLocaleLowerCase()
                                          )
                                    : s?.name
                            )
                            .map((item, index) => (
                                <Styles.ListItems
                                    key={index}
                                    onClick={() => {
                                        setSearchStr('');
                                        getSelectedItem(item);
                                    }}
                                >
                                    {item.name}
                                </Styles.ListItems>
                            ))}
                </Styles.ItemsWrapper>
            )}
        </>
    );
    return (
        <>
            {isMobile && showModal ? (
                <MobileDrawer
                    show
                    title={heading}
                    onClose={() => {
                        setSearchStr('');
                        closeModal();
                    }}
                >
                    <Styles.Wrapper>{content()}</Styles.Wrapper>
                </MobileDrawer>
            ) : // <Styles.Modal
            //     showModal={showModal}
            //     onCloseProps={() => {
            //         setSearchStr('');
            //         closeModal();
            //     }}
            // >
            //     <Styles.Heading>{heading || ''}</Styles.Heading>
            //     <Styles.Wrapper>{content()}</Styles.Wrapper>
            // </Styles.Modal>
            null}
        </>
    );
}
